import React, { memo } from "react";
import { Transition, Affix, Box, Group, Anchor } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import Icon from "./Icon";
import { useIsSmallScreen } from "./Utils";
import { Report } from "./EpIcon";

const BackTop = memo(function () {
  const [scroll, scrollTo] = useWindowScroll();
  const isSmallScreen = useIsSmallScreen();

  return (
    <Affix
      position={{ bottom: 50, right: isSmallScreen ? 15 : 30 }}
      className="eigenphi_backtop_button"
    >
      <Transition transition="slide-up" mounted={scroll.y < 600}>
        {(transitionStyles) => (
          <Anchor
            style={transitionStyles}
            href={"mailto:bug@eigenphi.com"}
            title={"Feedback by email"}
            sx={(theme) => ({
              borderRadius: "50%",
              width: 44,
              height: 44,
              backgroundColor: "#44D7B6",
              color: "#FFFFFF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              boxShadow:
                theme.colorScheme === "dark"
                  ? "0 4px 12px 0 rgba(0,0,0,0.50)"
                  : "0 4px 12px 0 #FFFFFF",
            })}
          >
            <Report />
          </Anchor>
        )}
      </Transition>
      <Transition transition="slide-up" mounted={scroll.y > 600}>
        {(transitionStyles) => (
          <Group style={transitionStyles}>
            <Anchor
              href={"mailto:bug@eigenphi.com"}
              title={"Feedback by email"}
              sx={(theme) => ({
                borderRadius: "50%",
                width: 44,
                height: 44,
                backgroundColor: "#44D7B6",
                color: "#FFFFFF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow:
                  theme.colorScheme === "dark"
                    ? "0 4px 12px 0 rgba(0,0,0,0.50)"
                    : "0 4px 12px 0 #FFFFFF",
              })}
            >
              <Report />
            </Anchor>
            <Box
              onClick={() => scrollTo({ y: 0 })}
              sx={(theme) => ({
                borderRadius: "50%",
                width: 44,
                height: 44,
                color: "#FFFFFF",
                backgroundColor:
                  theme.colorScheme === "dark" ? "#373A40" : "#CED4DA",
                "&:hover": {
                  backgroundColor: "#44D7B6",
                  color: "#FFFFFF",
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow:
                  theme.colorScheme === "dark"
                    ? "0 4px 12px 0 rgba(0,0,0,0.50)"
                    : "0 4px 12px 0 #FFFFFF",
              })}
            >
              <Icon name="icon-top-filling" size={24} />
            </Box>
          </Group>
        )}
      </Transition>
    </Affix>
  );
});

export default BackTop;
